/**
 * Pure helper for building dealer-site sub-page URLs (#1252). No window/config
 * deps → unit-testable (see dealerUrl.test.js). Used by runtimeConfig
 * `DEALER_RENTAL_URL` so the Rent CTA is origin-aware (test→test, prod→prod)
 * instead of hardcoding the prod origin.
 *
 * Takes the resolved dealer SITE url (may be a bare origin OR a full URL with a
 * sub-path, e.g. `https://dev.eezyworks.com/andys/sg-used-cars`), the site's
 * sub-path prefix (e.g. `/andys`), and the target page path (e.g. `/car-rental`),
 * and returns `origin + prefix + pagePath` without double-prefixing.
 *
 * @param {string} siteUrl — dealer site URL (origin or full URL).
 * @param {string} [pathPrefix] — sub-path prefix the dealer site is mounted on.
 * @param {string} [pagePath] — target page path.
 * @returns {string|null} composed URL, or null if inputs are unusable.
 */
export function composeDealerPageUrl(siteUrl, pathPrefix, pagePath) {
  let origin;
  try {
    origin = new URL(siteUrl).origin;
  } catch {
    return null;
  }

  let path = (pagePath || '').replace(/\/+$/, '');
  if (!path) return null;
  if (!path.startsWith('/')) path = `/${path}`;

  const prefix = (pathPrefix || '').replace(/\/+$/, '');
  // Don't double the prefix if the page path already carries it.
  const needPrefix = prefix && !path.startsWith(`${prefix}/`) && path !== prefix;

  return `${origin}${needPrefix ? prefix : ''}${path}`;
}
